import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css";
import "./index.css";

// Import mapping from character-pc
const characterAssets = [
  { name: "Edward Elric", id: "edward-elric" },
  { name: "Gintoki Sakata", id: "gintoki-sakata" },
  { name: "Gojo Satoru", id: "gojo-satoru" },
  { name: "Jonathan Joestar", id: "jonathan-joestar" },
  { name: "Killua Zoldyck", id: "killua-zoldyck" },
  { name: "Levi Ackerman", id: "levi-ackerman" },
  { name: "Lisa", id: "lisa" },
  { name: "Okabe Rintaro", id: "okabe-rintaro" },
  { name: "Rem", id: "rem" },
  { name: "Spike Spiegel", id: "spike-spiegel" },
  { name: "Yor Forger", id: "yor-forger" },
  { name: "Yukinoshita", id: "yukinoshita" },
  { name: "前田拳太郎", id: "kentaro-maeda" },
  { name: "大野智", id: "satoshi-ohno" },
  { name: "山崎賢人", id: "kento-yamazaki" },
  { name: "志尊淳", id: "jun-shison" },
  { name: "爆豪勝己", id: "bakugo-katsuki" },
  { name: "目黒蓮", id: "ren-meguro" },
  { name: "相葉雅紀", id: "masaki-aiba" },
  { name: "米津玄師", id: "kenshi-yonezu" },
  { name: "綾野剛", id: "go-ayano" },
  { name: "羽生結弦", id: "yuzuru-hanyu" },
  { name: "芦田愛菜", id: "mana-ashida" },
  { name: "菅田将暉", id: "masaki-suda" },
  { name: "道枝駿佑", id: "shunsuke-michieda" },
];

export default function AvatarSlider() {
  return (
    <Splide
      className="character-slider"
      extensions={{ AutoScroll }}
      options={{
        type: "loop",
        drag: 'free',
        focus: "center",
        perPage: 6,
        gap: 24,
        arrows: false,
        pagination: false,
        autoScroll: {
          pauseOnHover: false,
          pauseOnFocus: false,
          rewind: false,
          speed: 1,
        },
        autoWidth: true,
        height: "82px",
        breakpoints: {
          576: {
            height: "40px",
            gap: 0,
          }
        }
      }}
    >
      {characterAssets.map((char, index) => (
        <SplideSlide key={index} className="character-slide">
          <div className="character-pill">
            <div className="pill-avatar">
              <img
                src={require(`../../assets/images/character-pc/${char.id}.webp`)}
                alt={char.name}
              />
            </div>
            <span className="pill-name global-text">{char.name}</span>
          </div>
        </SplideSlide>
      ))}
    </Splide>
  );
}
